import { Component, ContentChild, Input, type OnInit, TemplateRef, computed, inject, signal } from '@angular/core';
import { NavigationEnd, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { LoadingService } from '@app/core/loading.service';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss'
})
export class LoadingOverlayComponent implements OnInit {
  loadingService = inject(LoadingService);

  @Input() detectRouteTransitions = true;

  @ContentChild("loading")
  customLoadingIndicator: TemplateRef<any> | null = null;

  message = computed(() => {
    const originalMessage = this.loadingService.loadingMessage();
    if (originalMessage && originalMessage.endsWith('.')) {
      return originalMessage?.slice(0, -1);
    }
    return originalMessage;
  })

  constructor(
    private router: Router
  ) {
    
  }

  ngOnInit() {
    // if (this.detectRouteTransitions) {
    //   this.router.events.pipe(
    //     tap((event) => {
    //       if (event instanceof NavigationStart) {
    //         this.loadingService.loadingOn('route-transition', 'loading page', 3000);
    //       } else if (event instanceof NavigationEnd) {
    //         this.loadingService.loadingOff('route-transition');
    //       }
    //     })
    //   ).subscribe();
    // }
  }

}
